import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './views/Home.vue'
import Default from './views/home/Default.vue'
import Books from './views/home/Books.vue'
import Tags from './views/home/Tags.vue'
import AddQuote from './views/AddQuote.vue'
import Settings from './views/Settings.vue'
import Quote from './views/Quote.vue'
import Book from './views/Book.vue'
import Tag from './views/Tag.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/',
      component: Home,
      children: [
        { path: '', name: 'home', component: Default },
        { path: 'books', name: 'books', component: Books },
        { path: 'tags', name: 'tags', component: Tags }
      ]
    },
    { path: '/add/', name: 'add', component: AddQuote },
    { path: '/settings/', name: 'settings', component: Settings },
    { path: '/quote/:id/', name: 'quote', component: Quote, meta: { transitionName: 'slide' } },
    { path: '/book/:id/', name: 'book', component: Book, meta: { transitionName: 'slide' } },
    { path: '/tag/:tag/', name: 'tag', component: Tag, meta: { transitionName: 'slide' } }
  ]
})

export default router
